module.exports = __webpack_public_path__ + "img/category-chromatography.5e41d4c4.svg";